import * as io from 'io-ts';

import { responseDecoder } from './TOEncoderDecoder';

/**
 * Schema for a user's reply to a study card.
 */
const _StudyCardReplyTODecoder = io.type({
  cardGuid: io.string,
  answer: io.number,
  timeToAnswer: io.union([io.number, io.null]),
  text: io.union([io.array(io.string), io.null]),
});

/**
 * Schema for a single study card.
 */
const StudyCardTODecoder = io.type({
  guid: io.string,
  answer: io.union([io.string, io.null]),
  explanation: io.union([io.string, io.null]),
  answers: io.union([io.array(io.string), io.null]),
  question: io.string,
  incorrectAnswers: io.union([io.array(io.string), io.null]),
  assignmentCreatedOn: io.string,
  assignmentType: io.string,
  category: io.string,
  deckName: io.string,
  deckType: io.string,
  due: io.string,
  feedback: io.union([io.string, io.null]),
  laps: io.number,
  cycle: io.string,
  media: io.union([io.array(io.type({ '@type': io.string, id: io.string })), io.null]),
});

/**
 * Main schema for the entire study session state.
 */
const StudySessionTODecoder = io.type({
  id: io.string,
  startedOn: io.string,
  updatedOn: io.string,
  hasAssignments: io.boolean,
  progress: io.record(io.string, io.type({ total: io.number, done: io.number })),
  tomorrow: io.record(io.string, io.number),
});

export type StudyCardReplyTO = io.TypeOf<typeof _StudyCardReplyTODecoder>;
export type StudyCardTO = io.TypeOf<typeof StudyCardTODecoder>;
export type StudySessionTO = io.TypeOf<typeof StudySessionTODecoder>;

export const studySessionTOResponseDecoder = responseDecoder<StudySessionTO | null>(
  io.union([StudySessionTODecoder, io.null]),
);

export const studyCardTOResponseDecoder = responseDecoder<StudyCardTO | null>(io.union([StudyCardTODecoder, io.null]));
